import type { KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function isKycRequired(kycInfo: KycResponse) {
  return Boolean(kycInfo.activeProcess);
}
